<template src="./OrkProductCart.html"/>
<style lang='scss' scoped src="./OrkProductCart.scss"/>

<script>

import {
  SfIcon,
  SfButton,
  SfImage,
  SfLoader
} from '@storefront-ui/vue';
import Api from "@/api/Api";
import icons from "@/utils/icons";
import OrkPrice from "@/components/Ork/OrkPrice";
import GtagEvent from "@/utils/GtagEvent";

export default {
  name: 'OrkProductCart',
  components: {
    OrkPrice,
    SfButton,
    SfImage,
    SfIcon,
    SfLoader
  },
  props: {
    activeCategory: {
      default: null,
    },
    product: {
      default: "",
    },
    isInWishlist: {
      type: Boolean,
      default: false,
    },

  },
  data() {
    return {
      showWishlist: process.env.VUE_APP_WISHLIST,
      loading: false,
    };
  },
  computed: {
    currentCart: {
      get() {
        return this.$store.getters.getCart;
      }
    },

    currentWishlistIcon() {
      return this.isInWishlist ? icons.wishlistFill : icons.wishlistStroke;
    },
    wishlistIconClasses() {
      const defaultClass = "sf-button--pure sf-product-card__wishlist-icon";
      return `${defaultClass} ${this.isInWishlist ? "on-wishlist" : ""}`;
    },
  },

  watch: {},
  methods: {
    goToProductPage() {
      if (this.activeCategory) {
        sessionStorage.setItem("activeCategory", this.activeCategory);
      }
      this.$router.push(this.$localizePath('/produit/' + this.product.slug))
    },
    toggleIsInWishlist() {
      this.$emit("click:wishlist", !this.isInWishlist);
    },
    setOfferQuantity(params) {
      let cart = params.currentCart,
          itemIsInCart = null,
          qty = params.quantity,
          prevQty = 0,
          stock = params.stock;

      if (cart && cart.cartItems && cart.cartItems.length) {
        itemIsInCart = cart.cartItems.find(item => item.product?.offer?.id === params.offerId);

        if (itemIsInCart) {
          prevQty = itemIsInCart?.quantity || 0;
          stock = itemIsInCart?.product.offer.stockQuantity || 0;
        }
      }

      if (prevQty + qty > stock) {
        this.$store.dispatch('sendNotification', {
          type: 'info',
          message: this.$i18n.t('addToCart.max'),
          icon: icons.info
        });

      } else {
        this.loading = true;
        Api.cart.setOfferQuantity(params)
            .then(data => {
              this.$store.dispatch('setCart', data);
              GtagEvent.AddToCartLight(this.product, qty, this.currentCart)
              this.$store.dispatch('toggleProductsActionModal', {
                open: true,
                type: params.method,
                product: this.product.name
              });
              this.$store.dispatch('sendNotification', {
                type: 'info',
                message: this.$i18n.t('addToCart.add'),
                icon: icons.info
                //icons.cart
              });
              if (!window['disable-facebook']) {
                fbq('track', "AddToCart");
              }
              /*
                 window.dataLayer = window.dataLayer || [];

                 window.dataLayer.push({
                   "event": "add_to_cart",
                   "ecommerce": {
                     "currency": "EUR",
                     "value": this.product.price,
                     "items": [{
                       "item_id": this.product.reference,
                       "item_name": this.product.name,
                       "price": this.product.price,
                       "quantity": params.quantity,
                       "item_brand": this.product.brand,
                       "item_category": this.activeCategory,
                     }]
                   }
                 });
                 window.dataLayer.push({
                   "event": "purchase",
                   "ecommerce": {
                     "currency": "EUR",
                     "value": this.product.price,
                     "tax": 7.18,
                     "shipping": 10.00,
                     "affiliation": 'My Parka Store',
                     "transaction_id": 'p115-20202000',
                     "coupon": 'free_back_rub',
                     "items": [{
                       "item_id": this.product.reference,
                       "item_name": this.product.name,
                       "price": this.product.price,
                       "quantity": params.quantity,
                       "item_brand": this.product.brand,
                       "item_category": this.activeCategory,
                     }]
                   }
                 });
   */
            })

            .catch((e) => {
              console.error(e);
              this.$store.dispatch('sendNotification', {
                type: 'danger',
                message: this.$i18n.t('errors.server.access'),
                icon: icons.error
              });
              this.error = e;
            })
            .finally(() => {
              this.loading = false
            });
      }
    },
  }
};
</script>


